export const enum AppThemeEnum {
  light = 'light',
  dark = 'dark',
}
